import MixpanelTracker from 'Mixpanel/mixpanelTracker';
import Action from 'Mixpanel/Model/action';
import { getMergedRichTextFormattingProperties } from 'Mixpanel/utils/richTextFormatting';
import { SPEAKERS, SPEAKERS_ADDED, RICH_TEXT_IN_SPEAKER_BIO } from '../../../mixpanelConstants';

const mixpanelTracker = new MixpanelTracker();

export function trackRichTextInSpeakerBio(bios) {
  const properties = {
    Action: Action.EDIT,
    ...getMergedRichTextFormattingProperties(bios)
  };
  mixpanelTracker.setEventName(RICH_TEXT_IN_SPEAKER_BIO);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}
export function trackSpeakerUpdate(
  checkboxSelectedCount, speakersAddedCount, imagesUploadedCount,
  namesAddedCount, emailsAddedCount, titlesAddedCount,
  bioAddedCount, organizationAddedCount, fbAddedCount,
  twitterAddedCount, linkedinAddedCount, websiteAddedCount
) {
  const properties = {
    Type: SPEAKERS,
    Action: Action.ADD,
    checkboxSelectedCount,
    speakersAddedCount,
    imagesUploadedCount,
    namesAddedCount,
    emailsAddedCount,
    titlesAddedCount,
    bioAddedCount,
    organizationAddedCount,
    fbAddedCount,
    twitterAddedCount,
    linkedinAddedCount,
    websiteAddedCount
  };
  mixpanelTracker.setEventName(SPEAKERS_ADDED);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}
